// extracted by mini-css-extract-plugin
module.exports = {"widthConstrain":"PromoStrip_widthConstrain__g3hS7","promoStrip":"PromoStrip_promoStrip__UR_lM","isLink":"PromoStrip_isLink__frwfH","promoText":"PromoStrip_promoText__rH6pv"};